const COMMODITIES = {
  SOJA: { code: 1, name: 'Soja', icon: 'soja', labelPtBr: 'Soja' },
  MILHO: { code: 2, name: 'Milho', icon: 'milho', labelPtBr: 'Milho' },
  BOI: { code: 3, name: 'Boi', icon: 'boi', labelPtBr: 'Boi' },
  CAFE: { code: 4, name: 'Café', icon: 'cafe', labelPtBr: 'Café' },
  ALGODAO: { code: 5, name: 'Algodão', icon: 'algodao', labelPtBr: 'Algodão' },
  ACUCAR: { code: 6, name: 'Açúcar', icon: 'acucar', labelPtBr: 'Açúcar' },
  FRANGO: { code: 7, name: 'Frango', icon: 'frango', labelPtBr: 'Frango' },
  SUINO: { code: 8, name: 'Suíno', icon: 'suino', labelPtBr: 'Suíno' },
  ARROZ: { code: 9, name: 'Arroz', icon: 'arroz', labelPtBr: 'Arroz' },
}

function makeId(index) {
  return `mock_flash_${String(index).padStart(3, '0')}`
}

const authors = [
  { name: 'Maria Santos', image_path: null, resume: '', nickname: 'msantos' },
  { name: 'João Pereira', image_path: null, resume: '', nickname: 'jpereira' },
  { name: 'Ana Oliveira', image_path: null, resume: '', nickname: 'aoliveira' },
  { name: 'Carlos Lima', image_path: null, resume: '', nickname: 'clima' },
  { name: 'Fernanda Costa', image_path: null, resume: '', nickname: 'fcosta' },
]

function daysAgo(days) {
  const d = new Date()
  d.setDate(d.getDate() - days)
  d.setHours(d.getHours() - Math.floor(Math.random() * 12))
  d.setMinutes(Math.floor(Math.random() * 60))
  return d.toISOString()
}

export const mockFlashFeed = [
  {
    _id: makeId(1),
    uuid: `uuid-${makeId(1)}`,
    displayDetail: true,
    content: {
      title: { data: 'Soja: safra 2025/26 atinge 95% da área colhida no Brasil' },
      abstract: { data: 'Trabalhos de colheita avançam no Centro-Oeste com clima favorável' },
      body: { data: '<p>Conteúdo completo da notícia sobre a safra de soja.</p>' },
    },
    dt_publish: daysAgo(0),
    dt_report: daysAgo(0),
    subjects: [COMMODITIES.SOJA],
    hat: [{ name: 'URGENTE' }],
    author: authors[0],
    image: 'https://picsum.photos/seed/soja1/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/soja1/400/300' },
    gallery: [
      'https://picsum.photos/seed/soja1/800/1200',
      'https://picsum.photos/seed/soja3/800/1200',
      'https://picsum.photos/seed/soja4/800/1200',
    ],
    youtubeId: null,
    tags: [{ name: 'Safra' }, { name: 'Colheita' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: true,
    exclusive: false,
    inLive: false,
    importance: 1,
    disclosureType: null,
  },
  {
    _id: makeId(2),
    uuid: `uuid-${makeId(2)}`,
    displayDetail: true,
    content: {
      title: { data: 'Milho: Chicago opera em alta com demanda aquecida' },
      abstract: { data: 'Mercado futuro do milho registra ganhos nesta sessão' },
      body: { data: '<p>Análise do mercado futuro de milho.</p>' },
    },
    dt_publish: daysAgo(0),
    dt_report: daysAgo(0),
    subjects: [COMMODITIES.MILHO],
    hat: [],
    author: authors[1],
    image: 'https://picsum.photos/seed/milho1/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/milho1/400/300' },
    youtubeId: 'EitHYL-LjQk',
    tags: [{ name: 'CBOT' }, { name: 'Mercado' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(3),
    uuid: `uuid-${makeId(3)}`,
    displayDetail: true,
    content: {
      title: { data: 'Boi gordo: preços seguem firmes em São Paulo' },
      abstract: { data: 'Escalas de abastecimento curtas sustentam cotações' },
      body: { data: '<p>Mercado físico do boi gordo.</p>' },
    },
    dt_publish: daysAgo(0),
    dt_report: daysAgo(0),
    subjects: [COMMODITIES.BOI],
    hat: [{ name: 'EXCLUSIVO' }],
    author: authors[2],
    image: 'https://picsum.photos/seed/boi1/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/boi1/400/300' },
    youtubeId: null,
    tags: [{ name: 'Pecuária' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: true,
    inLive: false,
    importance: 1,
    disclosureType: null,
  },
  {
    _id: makeId(4),
    uuid: `uuid-${makeId(4)}`,
    displayDetail: true,
    content: {
      title: { data: 'Café: exportações brasileiras crescem 25% em junho' },
      abstract: { data: 'Volume embarcado supera 3 milhões de sacas no mês' },
      body: { data: '<p>Dados do comércio exterior de café.</p>' },
    },
    dt_publish: daysAgo(1),
    dt_report: daysAgo(1),
    subjects: [COMMODITIES.CAFE],
    hat: [],
    author: authors[3],
    image: 'https://picsum.photos/seed/cafe1/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/cafe1/400/300' },
    youtubeId: null,
    tags: [{ name: 'Exportação' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(5),
    uuid: `uuid-${makeId(5)}`,
    displayDetail: true,
    content: {
      title: { data: 'Algodão: clima seco preocupa produtores na Bahia' },
      abstract: { data: 'Falta de chuvas pode comprometer produtividade da safra' },
      body: { data: '<p>Condições climáticas para o algodão.</p>' },
    },
    dt_publish: daysAgo(1),
    dt_report: daysAgo(1),
    subjects: [COMMODITIES.ALGODAO],
    hat: [],
    author: authors[4],
    image: 'https://picsum.photos/seed/algodao1/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/algodao1/400/300' },
    youtubeId: null,
    tags: [{ name: 'Clima' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(6),
    uuid: `uuid-${makeId(6)}`,
    displayDetail: true,
    content: {
      title: { data: 'Análise técnica: cenário para o açúcar no curto prazo' },
      abstract: { data: 'Especialista comenta perspectivas para o mercado de açúcar' },
      body: { data: '<p>Análise detalhada do mercado de açúcar.</p>' },
    },
    dt_publish: daysAgo(1),
    dt_report: daysAgo(1),
    subjects: [COMMODITIES.ACUCAR],
    hat: [],
    author: authors[0],
    image: null,
    thumb: { image_path: null },
    youtubeId: 'trfrctmpyHE',
    tags: [{ name: 'Análise' }],
    newsContent: [{ code: 4, namePtBr: 'Consultoria' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(7),
    uuid: `uuid-${makeId(7)}`,
    displayDetail: true,
    content: {
      title: { data: 'Frango: preços estáveis com oferta equilibrada' },
      abstract: { data: 'Mercado avícola mantém estabilidade nesta semana' },
      body: { data: '<p>Acompanhamento do mercado de frango.</p>' },
    },
    dt_publish: daysAgo(2),
    dt_report: daysAgo(2),
    subjects: [COMMODITIES.FRANGO],
    hat: [],
    author: authors[1],
    image: 'https://picsum.photos/seed/frango1/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/frango1/400/300' },
    gallery: [
      'https://picsum.photos/seed/frango1/800/1200',
      'https://picsum.photos/seed/frango2/800/1200',
    ],
    youtubeId: null,
    tags: [{ name: 'Preços' }],
    newsContent: [{ code: 13, namePtBr: 'Mercado Físico' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(8),
    uuid: `uuid-${makeId(8)}`,
    displayDetail: true,
    content: {
      title: { data: 'Suíno: China reduz importações e impacto no mercado brasileiro' },
      abstract: { data: 'Queda na demanda chinesa pressiona cotações internas' },
      body: { data: '<p>Análise do mercado suinícola.</p>' },
    },
    dt_publish: daysAgo(2),
    dt_report: daysAgo(2),
    subjects: [COMMODITIES.SUINO],
    hat: [{ name: 'ANÁLISE' }],
    author: authors[2],
    image: null,
    thumb: { image_path: null },
    youtubeId: null,
    tags: [{ name: 'Exportação' }, { name: 'China' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(9),
    uuid: `uuid-${makeId(9)}`,
    displayDetail: true,
    content: {
      title: { data: 'Arroz: safra gaúcha deve crescer 8% segundo projeções' },
      abstract: { data: 'Estimativa aponta recuperação após desafios climáticos' },
      body: { data: '<p>Projeções para a safra de arroz.</p>' },
    },
    dt_publish: daysAgo(2),
    dt_report: daysAgo(2),
    subjects: [COMMODITIES.ARROZ],
    hat: [],
    author: authors[3],
    image: 'https://picsum.photos/seed/arroz1/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/arroz1/400/300' },
    youtubeId: null,
    tags: [{ name: 'Safra' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(10),
    uuid: `uuid-${makeId(10)}`,
    displayDetail: true,
    content: {
      title: { data: 'Soja: preços em Chicago recuam com expectativa de safra recorde nos EUA' },
      abstract: { data: 'Condições climáticas favoráveis no Meio-Oeste americano pressionam cotações' },
      body: { data: '<p>Mercado internacional de soja.</p>' },
    },
    dt_publish: daysAgo(3),
    dt_report: daysAgo(3),
    subjects: [COMMODITIES.SOJA],
    hat: [],
    author: authors[4],
    image: 'https://picsum.photos/seed/soja2/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/soja2/400/300' },
    gallery: [
      'https://picsum.photos/seed/soja2/800/1200',
      'https://picsum.photos/seed/soja5/800/1200',
      'https://picsum.photos/seed/soja6/800/1200',
    ],
    youtubeId: null,
    tags: [{ name: 'CBOT' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(11),
    uuid: `uuid-${makeId(11)}`,
    displayDetail: true,
    content: {
      title: { data: 'Milho: entressafra pressiona preços domésticos' },
      abstract: { data: 'Oferta reduzida sustenta cotações nas principais praças' },
      body: { data: '<p>Mercado doméstico de milho.</p>' },
    },
    dt_publish: daysAgo(3),
    dt_report: daysAgo(3),
    subjects: [COMMODITIES.MILHO],
    hat: [],
    author: authors[0],
    image: null,
    thumb: { image_path: null },
    youtubeId: null,
    tags: [{ name: 'Mercado Doméstico' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(12),
    uuid: `uuid-${makeId(12)}`,
    displayDetail: true,
    content: {
      title: { data: 'Boi: Brasil deve exportar recorde de carne bovina em 2025' },
      abstract: { data: 'Projeções indicam embarques superiores a 3 milhões de toneladas' },
      body: { data: '<p>Perspectivas para exportação de carne bovina.</p>' },
    },
    dt_publish: daysAgo(3),
    dt_report: daysAgo(3),
    subjects: [COMMODITIES.BOI],
    hat: [],
    author: authors[1],
    image: null,
    thumb: { image_path: null },
    youtubeId: 'WfS2M6jfEtU',
    tags: [{ name: 'Exportação' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: true,
    exclusive: false,
    inLive: false,
    importance: 1,
    disclosureType: null,
  },
  {
    _id: makeId(13),
    uuid: `uuid-${makeId(13)}`,
    displayDetail: true,
    content: {
      title: { data: 'Café: safra 2025/6 deve ser maior que a anterior, diz Conab' },
      abstract: { data: 'Bienalidade positiva favorece produção nacional' },
      body: { data: '<p>Estimativas da Conab para a safra de café.</p>' },
    },
    dt_publish: daysAgo(4),
    dt_report: daysAgo(4),
    subjects: [COMMODITIES.CAFE],
    hat: [{ name: 'EXCLUSIVO' }],
    author: authors[2],
    image: 'https://picsum.photos/seed/cafe2/800/1200',
    thumb: { image_path: 'https://picsum.photos/seed/cafe2/400/300' },
    youtubeId: null,
    tags: [{ name: 'Safra' }, { name: 'Conab' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: true,
    inLive: false,
    importance: 1,
    disclosureType: null,
  },
  {
    _id: makeId(14),
    uuid: `uuid-${makeId(14)}`,
    displayDetail: true,
    content: {
      title: { data: 'Algodão: placa do algodão sobe 3% no mercado internacional' },
      abstract: { data: 'Cotação externa reflete menor oferta global' },
      body: { data: '<p>Cotações internacionais do algodão.</p>' },
    },
    dt_publish: daysAgo(4),
    dt_report: daysAgo(4),
    subjects: [COMMODITIES.ALGODAO],
    hat: [],
    author: authors[3],
    image: null,
    thumb: { image_path: null },
    youtubeId: null,
    tags: [{ name: 'Cotações' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(15),
    uuid: `uuid-${makeId(15)}`,
    displayDetail: true,
    content: {
      title: { data: 'Soja: webinar discute perspectivas da safra 2025/26' },
      abstract: { data: 'Evento online reúne especialistas do setor no dia 25 de julho' },
      body: { data: '<p>Webinar sobre perspectivas da soja.</p>' },
    },
    dt_publish: daysAgo(5),
    dt_report: daysAgo(5),
    subjects: [COMMODITIES.SOJA, COMMODITIES.MILHO],
    hat: [],
    author: authors[4],
    image: null,
    thumb: { image_path: null },
    youtubeId: null,
    tags: [{ name: 'Evento' }, { name: 'Webinar' }],
    newsContent: [{ code: 4, namePtBr: 'Consultoria' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(16),
    uuid: `uuid-${makeId(16)}`,
    displayDetail: true,
    content: {
      title: { data: 'Tudo sobre o ciclo do milho: do plantio à colheita' },
      abstract: { data: 'Veja em 60 segundos as principais etapas da cultura do milho' },
      body: { data: '<p>Vídeo curto sobre o ciclo do milho.</p>' },
    },
    dt_publish: daysAgo(0),
    dt_report: daysAgo(0),
    subjects: [COMMODITIES.MILHO],
    hat: [{ name: 'VÍDEO' }],
    author: authors[0],
    image: null,
    thumb: { image_path: null },
    youtubeId: 'xURs9opuVbs',
    tags: [{ name: 'Milho' }, { name: 'Shorts' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
  {
    _id: makeId(17),
    uuid: `uuid-${makeId(17)}`,
    displayDetail: true,
    content: {
      title: { data: 'Preços da soja: o que esperar para o próximo mês' },
      abstract: { data: 'Análise rápida sobre as tendências do mercado da soja' },
      body: { data: '<p>Vídeo curto sobre preços da soja.</p>' },
    },
    dt_publish: daysAgo(0),
    dt_report: daysAgo(0),
    subjects: [COMMODITIES.SOJA],
    hat: [{ name: 'VÍDEO' }],
    author: authors[1],
    image: null,
    thumb: { image_path: null },
    youtubeId: '3DycsJ-wDEE',
    tags: [{ name: 'Soja' }, { name: 'Shorts' }],
    newsContent: [{ code: 1, namePtBr: 'Informativo' }],
    highlight: false,
    exclusive: false,
    inLive: false,
    importance: 0,
    disclosureType: null,
  },
]

export const COMMODITY_LIST = [
  { code: 0, name: 'Todas' },
  { code: 1, name: 'Soja' },
  { code: 2, name: 'Milho' },
  { code: 3, name: 'Boi' },
  { code: 4, name: 'Café' },
  { code: 5, name: 'Algodão' },
  { code: 6, name: 'Açúcar' },
  { code: 7, name: 'Frango' },
  { code: 8, name: 'Suíno' },
  { code: 9, name: 'Arroz' },
]
